import React from 'react';
import { SectionTitle, SliderRow, StyleGrid } from './ui-primitives';
import { DotPreview } from './canvas-previews';
const DOT_STYLES = [
    { id: 'square', label: 'Square' },
    { id: 'squarernd', label: 'Sqr Rnd' },
    { id: 'rounded', label: 'Rounded' },
    { id: 'dot', label: 'Dot' },
    { id: 'liquid', label: 'Liquid' },
    { id: 'arrow', label: 'Arrow' },
    { id: 'heart', label: 'Heart' },
    { id: 'star', label: 'Star' },
    { id: 'triangle', label: 'Triangle' },
    { id: 'block', label: 'Block' },
];
export const DotsPanel = ({ settings, update }) => {
    return (<div className="space-y-4">
            <SectionTitle>Dot Style</SectionTitle>
            <StyleGrid items={DOT_STYLES} selected={settings.dotStyle} onSelect={(id) => update('dotStyle', id)} renderPreview={(id) => <DotPreview style={id} color="#494DAD"/>}/>

            <div className="space-y-3 pt-2">
                <SectionTitle>Size &amp; Shape</SectionTitle>
                <SliderRow label="Dot Size" value={settings.dotSize} min={0.4} max={1.0} step={0.01} onChange={(v) => update('dotSize', v)} display={settings.dotSize.toFixed(2)}/>
                <SliderRow label="Padding" value={settings.padding} min={8} max={56} step={1} onChange={(v) => update('padding', v)} display={`${settings.padding}px`}/>
                {settings.dotStyle === 'rounded' && (<SliderRow label="Roundness" value={settings.roundness} min={0.05} max={0.5} step={0.01} onChange={(v) => update('roundness', v)} display={settings.roundness.toFixed(2)}/>)}
                {settings.dotStyle === 'liquid' && (<SliderRow label="Merge" value={settings.merge} min={0.1} max={0.55} step={0.01} onChange={(v) => update('merge', v)} display={settings.merge.toFixed(2)}/>)}
            </div>
        </div>);
};
DotsPanel.displayName = 'DotsPanel';
